/**
 * A página dos agentes (o conector no Claude e no ChatGPT). Desde 17/10/2026 o
 * app é só do admin: o aluno cria a conta e a senha aqui e usa os agentes por
 * lá. Decisão da Adri: "Novo e antigo, página".
 */
import { supabase } from "@/infra/supabase/client";

export const PAGINA_DOS_AGENTES =
  import.meta.env.VITE_AGENTES_URL || "https://agentes.engenhariadosim.com.br";

/** O aviso que a página mostra no topo: conta criada ou senha nova criada. */
export type AvisoDosAgentes = "conta" | "senha";

export function urlDosAgentes(aviso?: AvisoDosAgentes): string {
  const url = new URL(PAGINA_DOS_AGENTES);
  if (aviso) url.searchParams.set("aviso", aviso);
  return url.toString();
}

/**
 * Leva o aluno pra página dos agentes, saindo do app antes: a sessão do app
 * não serve pra nada lá, e o conector entra com e-mail e senha.
 */
export async function irParaOsAgentes(aviso?: AvisoDosAgentes): Promise<void> {
  await supabase.auth.signOut().catch(() => undefined);
  window.location.replace(urlDosAgentes(aviso));
}
